export const language: any = {
    cancel: "キャンセル",
    ok: "はい",
};